"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openPdfOnBrowser = void 0;
var openPdfOnBrowser = function (path) {
    window.open(path, '_blank');
};
exports.openPdfOnBrowser = openPdfOnBrowser;
